import { Component, OnDestroy, TemplateRef } from '@angular/core';

import { CarouselAreaDirective } from './carousel-area.directive';


@Component({
  selector: 'carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.less']
})
export class CarouselComponent implements OnDestroy {
  panels: TemplateRef<any>[] = [];

  ngOnDestroy(): void {
    this.panels = null;
  }


  public removeImage = (item: CarouselAreaDirective) =>
    this.panels = this.panels.filter(s => s != item.template);


  public addImage = (item: CarouselAreaDirective) =>
    this.panels.push(item.template);


}
